import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTwap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M6.33 1.67a.75.75 0 0 1 0 1.06L3.784 5.276a.75.75 0 0 1-1.06-1.06L5.269 1.67a.75.75 0 0 1 1.061 0ZM17.67 1.67a.75.75 0 0 1 1.06 0l2.546 2.545a.75.75 0 1 1-1.06 1.061L17.67 2.73a.75.75 0 0 1 0-1.06ZM12 2.75c-5.385 0-9.75 4.365-9.75 9.75a9.719 9.719 0 0 0 2.825 6.864l-1.607 1.607a.75.75 0 1 0 1.06 1.06l1.685-1.683A9.706 9.706 0 0 0 12 22.25a9.707 9.707 0 0 0 5.787-1.902l1.683 1.682a.75.75 0 0 0 1.06-1.06l-1.606-1.606A9.719 9.719 0 0 0 21.75 12.5c0-5.385-4.365-9.75-9.75-9.75ZM3.75 12.5a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Z"
    />
    <path
      fill="#F7A600"
      d="M12.043 17.5a.536.536 0 0 1-.536-.536V8.036a.536.536 0 1 1 1.072 0v8.928c0 .296-.24.536-.536.536Zm1.543-6.7a.97.97 0 0 0-.445-.734c-.262-.174-.618-.261-1.068-.261-.305 0-.563.039-.773.117a1.09 1.09 0 0 0-.484.316.714.714 0 0 0-.164.461.609.609 0 0 0 .1.375c.074.107.176.2.306.278.13.075.28.141.45.199.17.054.35.101.544.14l.795.172c.386.078.74.183 1.063.313.322.13.602.29.838.48s.42.414.549.672c.132.258.2.554.203.887-.003.49-.141.914-.415 1.273-.27.357-.662.634-1.175.832-.51.196-1.125.293-1.845.293-.715 0-1.337-.099-1.867-.297-.527-.197-.939-.49-1.236-.878-.293-.391-.448-.874-.462-1.45h1.81c.02.269.106.492.255.672.153.177.356.311.61.402.256.089.546.133.868.133.317 0 .592-.041.825-.125.237-.083.42-.199.55-.347a.756.756 0 0 0 .194-.512c0-.18-.06-.33-.177-.453a1.357 1.357 0 0 0-.51-.313 5.602 5.602 0 0 0-.817-.234l-.964-.219c-.746-.164-1.335-.42-1.767-.77-.432-.348-.647-.818-.644-1.41a1.96 1.96 0 0 1 .428-1.269c.291-.362.69-.645 1.197-.848.507-.203 1.083-.304 1.728-.304.657 0 1.23.101 1.72.304.493.203.876.486 1.15.848.273.362.414.781.423 1.258h-1.793Z"
    />
  </svg>
);
export default SvgTwoColorTwap;
